import { useEffect, useState } from "react";
import axios from 'axios';
import {Link, useHistory} from 'react-router-dom';

const Dashboard = () =>{

    const [message, setMessage] = useState()

    const history = useHistory();

    axios.defaults.withCredentials = true; 
    useEffect(() =>{
        axios.get("http://localhost:8000/dashboard")
        .then(res => {
            if(res.data.valid) {
                setMessage(res.data.message)
            }else{
                history.push('/')
            }
        })
        .catch(err => console.log(err))
    })

    return(
        <div>
            <p>Welcome to the DASHBOARD! - {message}</p>
            <p>You can access all <Link to="/register" id="link"> MOVIES</Link> now</p>
        </div>
    )
}

export default Dashboard;